(() => {
  if (customElements.get('adma-etsy-reviews')) return;
  const requests = new Map();
  class EtsyReviews extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.page = 0;
      this.size = this.dataset.mode === 'rail' ? 6 : 12;
      this.$ = s => this.querySelector(s);
      this.search = this.$('.adma-search');
      this.search.addEventListener('input', () => { this.page = 0; this.render(); });
      this.$('.adma-prev').addEventListener('click', () => this.move(-1));
      this.$('.adma-next').addEventListener('click', () => this.move(1));
      const observer = new IntersectionObserver(entries => {
        if (entries.some(e => e.isIntersecting)) { observer.disconnect(); this.load(); }
      }, {rootMargin: '300px'});
      observer.observe(this);
    }
    async load() {
      try {
        const url = this.dataset.url;
        if (!requests.has(url)) requests.set(url, url === 'inline'
          ? Promise.resolve(JSON.parse(document.getElementById('adma-inline-data').textContent))
          : fetch(url, {credentials:'same-origin'}).then(r => { if (!r.ok) throw Error('Load failed'); return r.json(); }));
        this.rows = await requests.get(url);
        if (!Array.isArray(this.rows) || this.rows.some(r => !Number.isInteger(r.star_rating) || r.star_rating < 1 || r.star_rating > 5 || ['reviewer','message','date_reviewed'].some(k => typeof r[k] !== 'string'))) throw Error('Invalid collection');
        this.render();
      } catch {
        this.$('.adma-status').textContent = 'Reviews could not be loaded. Reload this page to try again.';
        this.$('.adma-prev').disabled = this.$('.adma-next').disabled = true;
      }
    }
    move(delta) { this.page += delta; this.render(); }
    render() {
      if (!this.rows) return;
      const query = this.search.value.toLocaleLowerCase();
      const rows = this.rows.filter(r => `${r.message} ${r.reviewer}`.toLocaleLowerCase().includes(query));
      const pages = Math.max(1, Math.ceil(rows.length / this.size));
      this.page = Math.max(0, Math.min(this.page,pages-1));
      const cards = this.$('.adma-cards');
      cards.replaceChildren();
      for (const r of rows.slice(this.page*this.size,(this.page+1)*this.size)) {
        const article = document.createElement('article');
        article.className = 'adma-card'; article.setAttribute('role','listitem');
        const stars = document.createElement('p'); stars.className = 'adma-stars'; stars.textContent = '★'.repeat(r.star_rating) + '☆'.repeat(5-r.star_rating); stars.setAttribute('aria-label',`${r.star_rating} out of 5 stars`);
        const text = document.createElement('blockquote'); text.textContent = r.message;
        if (!r.message.trim()) { const note = document.createElement('p'); note.className='adma-empty'; note.textContent='No written message supplied.'; article.append(note); }
        const name = document.createElement('p'); name.className='adma-reviewer'; name.textContent = r.reviewer;
        const date = document.createElement('p'); date.className='adma-date'; date.textContent = r.date_reviewed;
        article.prepend(stars,text); article.append(name,date); cards.append(article);
      }
      cards.scrollLeft = 0;
      this.$('.adma-status').textContent = rows.length ? `Showing ${this.page*this.size+1}–${Math.min((this.page+1)*this.size,rows.length)} of ${rows.length} matching review records.` : 'No matching review records.';
      this.$('.adma-page').textContent = `Page ${this.page+1} of ${pages}`;
      this.$('.adma-prev').disabled = this.page === 0;
      this.$('.adma-next').disabled = this.page >= pages-1;
      this.$('.adma-all').hidden = this.dataset.mode !== 'rail';
    }
  }
  customElements.define('adma-etsy-reviews',EtsyReviews);
})();
